<template>
  <div :class="['z-1000', inline ? 'ResetMapExtentControl--inline' : 'maplibregl-ctrl maplibregl-ctrl-group']">
    <MapControlTooltip :text="resetExtentLabel">
      <button
        class="maplibregl-ctrl-zoom-extent z-100 rounded-full size-10 center-blocs"
        :aria-label="resetExtentLabel"
        @click="applicationStore.triggerZoomReset = !applicationStore.triggerZoomReset"
      >
        <span class="maplibregl-ctrl-icon"></span>
      </button>
    </MapControlTooltip>
  </div>
</template>

<script setup lang="ts">
defineProps<{ inline?: boolean }>()

import MapControlTooltip from '@/components/map/controls/MapControlTooltip.vue'
import { useApplicationStore } from '@/stores/applicationStore'
import { useMyMapStore } from '@/stores/myMapStore'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const applicationStore = useApplicationStore()
const myMapStore = useMyMapStore()
const { t } = useI18n()

const resetExtentLabel = computed(() =>
  myMapStore.mapSearch
    ? t('geoportal.mapControls.resetExtentCommune')
    : t('geoportal.mapControls.resetExtent'),
)
</script>

<style lang="scss">
.maplibregl-ctrl-zoom-extent {
  .maplibregl-ctrl-icon {
    background-image: none;
    -webkit-mask-image: url(@/assets/images/icons/map/material-symbols-light--filter-center-focus-rounded.svg);
    mask-image: url(@/assets/images/icons/map/material-symbols-light--filter-center-focus-rounded.svg);
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-position: center;
    mask-position: center;
    -webkit-mask-size: 20px 20px;
    mask-size: 20px 20px;
    background-color: var(--color-main);
  }
}
</style>
